import { Component } from '@verndale/core';
import stickybits from 'stickybits';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $el: this.el,
      $header: _$('.header'),
      $doc: document.documentElement,
      $button: this.el._$('.back-to-top__button')
    };
    this.visible = false;
    this.stickybitsInstance = null;
    this.headerHeight = 0;

    this.init();
    this.detectScroll();
  } //setupDefaults

  addListeners() {
    const { $button } = this.dom;

    $button._on('click', this.goToTop.bind(this));
    window._on('scroll', this.detectScroll.bind(this));
  } //addListeners

  init() {
    const { $header } = this.dom;

    this.headerHeight = $header?.offsetHeight || 200;
  } //init

  goToTopFallback() {
    const currentScroll =
      document.documentElement.scrollTop || document.body.scrollTop;

    if (currentScroll > 3) {
      window.requestAnimationFrame(this.goToTopFallback.bind(this));
      window.scrollTo(0, currentScroll - currentScroll / 5);
    } else {
      window.scrollTo(0, 0);
    }
  } //goToTopFallback

  goToTop(e) {
    e.preventDefault();

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  } //goToTop

  sticky() {
    this.stickybitsInstance = stickybits(this.dom.$button, {
      verticalPosition: 'bottom',
      stickyBitStickyOffset: 10,
      useStickyClasses: false,
      useFixed: true
    });
  } //sticky

  detectScroll() {
    const { $el } = this.dom;
    const top =
      (window.pageYOffset || this.dom.$doc.scrollTop) -
      (this.dom.$doc.clientTop || 0);

    if (top > this.headerHeight && this.visible === false) {
      this.showButtom();
    } else if (top < this.headerHeight && this.visible === true) {
      this.hideButton();
    }
  } //detectScroll

  showButtom() {
    this.visible = true;
    const { $el } = this.dom;
    $el.classList.add('active');
    $el.classList.remove('inactive');
    this.sticky();
  } //showButtom

  hideButton() {
    this.visible = false;
    const { $el } = this.dom;
    $el.classList.remove('active');
    $el.classList.add('inactive');
    if (this.stickybitsInstance) {
      this.stickybitsInstance.cleanup();
    }
  } //hideButton
}

export default Module;
